/* unplugin-vue-components disabled */import { render } from "./CartView.vue?vue&type=template&id=428da2a8&scoped=true&ts=true"
import script from "./CartView.vue?vue&type=script&lang=ts"
export * from "./CartView.vue?vue&type=script&lang=ts"

import "./CartView.vue?vue&type=style&index=0&id=428da2a8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428da2a8"]])

export default __exports__